export var DefaultSegmentName;
(function (DefaultSegmentName) {
    DefaultSegmentName["all"] = "all";
    DefaultSegmentName["new"] = "new";
    DefaultSegmentName["regular"] = "regular";
    DefaultSegmentName["lapsing"] = "lapsing";
    DefaultSegmentName["prospective"] = "prospective";
})(DefaultSegmentName || (DefaultSegmentName = {}));
